// modal
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SHOW_ERROR_MODAL = "SHOW_ERROR_MODAL";
export const START_LOADING = "SHOW_LOADING";
export const FINISH_LOADING = "FINISH_LOADING";
